import { render } from "./TestInterview.vue?vue&type=template&id=b8880560&scoped=true"
import script from "./TestInterview.vue?vue&type=script&lang=js"
export * from "./TestInterview.vue?vue&type=script&lang=js"

import "./TestInterview.vue?vue&type=style&index=0&id=b8880560&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8880560"]])

export default __exports__